import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { ErrorBoundary, LdsRoller, PrivateRoute, Alert } from "../components";
const LawyerPage = lazy(() => import("../pages/lawyerPage"));
const LoginPage = lazy(() => import("../pages/loginPage"));
const Dashboard = lazy(() => import("./dashboard"));

function App() {
  return (
    <div className="app">
      <Suspense
        fallback={
          <div className="loader-container">
            <LdsRoller />
          </div>
        }
      >
        <Switch>
          <Route path="/" exact={true}>
            <ErrorBoundary>
              <Redirect to="/dashboard" />
            </ErrorBoundary>
          </Route>
          <PrivateRoute path="/dashboard">
            <ErrorBoundary>
              <Dashboard />
            </ErrorBoundary>
          </PrivateRoute>
          <Route path="/login">
            <ErrorBoundary>
              <LoginPage />
            </ErrorBoundary>
          </Route>
          <Route path="/:username">
            <ErrorBoundary>
              <LawyerPage />
            </ErrorBoundary>
          </Route>
        </Switch>
      </Suspense>

      <Alert />
    </div>
  );
}

export default App;
